/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactNode } from 'react';
import './LeaveAppliedContent.css';
import { Grid } from '@mui/material';
import { fonts, themes } from '../../themes/themes';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
interface contentTileType {
  leaveName: string;
  totalLeaveDays: number;
  startDate: string | ReactNode;
  endDate: string | ReactNode;
  status?: any;
  onClick?: any;
  encashtype?: string;
  amount?: number;
  payment_type?: string;
  onLeaveCancel?: any;
  onSendremaninder?: any;
  onRejoinForm?: any;
}
const LeaveAppliedContent: React.FC<contentTileType> = ({
  endDate,
  leaveName,
  startDate,
  totalLeaveDays,
  status,
  onClick,
  encashtype,
  amount,
  payment_type,
  onLeaveCancel,
  onSendremaninder,
  onRejoinForm,
}) => {
  const { t } = useTranslation();
  const trans = t;
  return (
    <Grid container className="leaveApplied-container">
      <Grid
        item
        xs={12}
        style={{
          fontSize: fonts.title,
          fontFamily: fonts.fontFamily,
          color: themes.blackDefault,
          fontWeight: 'bold',
          textTransform: 'capitalize',
        }}
      >
        {leaveName}
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: themes.defaultIcon,
          textTransform: 'capitalize',
          letterSpacing: '0.01px',
          marginTop: '10px',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
        }}
      >
        {trans('Total')} :{' '}
        <span style={{ color: themes.blackDefault }} className="mx-1">
          {totalLeaveDays}
        </span>{' '}
        {trans('Days')}
      </Grid>
      {payment_type && payment_type != '' && payment_type != 'undefined' ? (
        <Grid
          item
          xs={12}
          style={{
            fontSize: fonts.subtitle,
            fontFamily: fonts.fontFamily,
            color: themes.defaultIcon,
            textAlign: 'left',
            letterSpacing: '0.01px',
            marginTop: '2px',
            textTransform: 'capitalize',
          }}
        >
          {trans('Amount')}{' '}
          <span style={{ color: themes.blackDefault }}>{amount}</span>
        </Grid>
      ) : (
        ''
      )}
      {payment_type && payment_type != '' && payment_type != 'undefined' ? (
        <Grid
          item
          xs={12}
          style={{
            fontSize: fonts.subtitle,
            fontFamily: fonts.fontFamily,
            color: themes.defaultIcon,
            letterSpacing: '0.01px',
            marginTop: '2px',
            textTransform: 'capitalize',
          }}
        >
          {trans('Payment Type')}{' '}
          <span style={{ color: themes.blackDefault }}>
            {trans(payment_type)}
          </span>
        </Grid>
      ) : (
        ''
      )}
      {encashtype && encashtype != '' && encashtype != 'undefined' ? (
        <Grid
          item
          xs={12}
          style={{
            fontSize: fonts.subtitle,
            fontFamily: fonts.fontFamily,
            color: themes.defaultIcon,
            letterSpacing: '0.01px',
            marginTop: '2px',
            textTransform: 'capitalize',
          }}
        >
          {trans('Type')}{' '}
          <span style={{ color: themes.blackDefault }} className="mx-1">
            {trans(encashtype)}
          </span>
        </Grid>
      ) : (
        ''
      )}
      <Grid
        item
        xs={10}
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: themes.defaultIcon,
          letterSpacing: '0.01px',
          marginTop: '2px',
          textTransform: 'capitalize',
          whiteSpace: 'nowrap',
        }}
      >
        <span>{trans('Start')}</span>:
        <span style={{ color: themes.blackDefault }} className="mx-1">
          {startDate}
        </span>
        , <span className="mx-1">{trans('End')} : </span>
        <span style={{ color: themes.blackDefault }}>{endDate}</span>
      </Grid>

      <Grid
        item
        xs={12}
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: themes.defaultIcon,
          letterSpacing: '0.01px',
          textTransform: 'capitalize',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ marginTop: '3px' }}>
          {trans('Status')}:
          {status == 0 ? (
            <span style={{ color: themes.defaultMisc }} className="mx-1">
              {trans('Waiting For Approval')}
            </span>
          ) : status == 2 ? (
            <span style={{ color: themes.defaultError }} className="mx-1">
              {trans('Rejected')}
            </span>
          ) : status == 3 ? (
            <span style={{ color: themes.defaultError }} className="mx-1">
              {trans('Cancelled')}
            </span>
          ) : (
            <span style={{ color: themes.defaultSuccess }} className="mx-1">
              {trans('Approved')}
            </span>
          )}
        </div>
        <div>
          {status == 3 ? (
            <Box className="icon-box_leave_history_blank">
              <>{''}</>
            </Box>
          ) : (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Box className="icon-box_leave_history" data-tooltip="View" onClick={onClick}>
                {' '}
                <i className="las la-eye" />{' '}
              </Box>
              {status == 1 && (
                <Box className="icon-box_leave_rejoin" data-tooltip="Rejoin" onClick={onRejoinForm}>
                  {' '}
                  <i className="las la-sign-in-alt" />{' '}
                </Box>
              )}
              <div style={{ marginLeft: '2px' }}>
                {status != 1 && (
                  <Box
                    className="icon-box_leave_history"
                    onClick={onLeaveCancel}
                  >
                    {' '}
                    <i className="las la-times" style={{ color: 'red' }} />{' '}
                  </Box>
                )}
              </div>

              <div style={{ marginLeft: '2px' }}>
                {status != 1 && (
                  <Box
                    className="icon-box_leave_history"
                    onClick={onSendremaninder}
                  >
                    {' '}
                    <i
                      className="las la-concierge-bell !text-lg"
                      style={{ color: 'orange' }}
                    />{' '}
                  </Box>
                )}
              </div>
            </div>
          )}
        </div>
      </Grid>
    </Grid>
  );
};

export default LeaveAppliedContent;
